import { render } from "./AppTopbar.vue?vue&type=template&id=d13bfae2"
import script from "./AppTopbar.vue?vue&type=script&lang=js"
export * from "./AppTopbar.vue?vue&type=script&lang=js"

import "./AppTopbar.vue?vue&type=style&index=0&id=d13bfae2&lang=scss"
script.render = render

export default script